/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Max_Words_Per_Line_LabelInputs */



/**
* | output |
* | --- |
* | "Maximum Words/Line" |
*
* @param {Style_Guide_Manager_Max_Words_Per_Line_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_max_words_per_line_label = /** @type {((inputs?: Style_Guide_Manager_Max_Words_Per_Line_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Max_Words_Per_Line_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mots maximum par ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Wörter pro Zeile")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero massimo di parole/riga")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальное количество слов в строке")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máximo de palabras/línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每行最大字数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大単語数/行")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रति पंक्ति अधिकतम शब्द")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número máximo de palavras por linha")
	return /** @type {LocalizedString} */ ("Maximum Words/Line")
});